import React, {Component} from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

class MultipleSelector extends Component {
    render() {
        return (
            <ReactSelect isMulti options={this.props.options} value={this.props.value}
                         onChange={this.props.onSelected}/>
        );
    }
}

MultipleSelector.propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.any.isRequired,
    onSelected: PropTypes.func.isRequired
}

export default MultipleSelector;
